// extracted by mini-css-extract-plugin
module.exports = {"extra":"index_extra_2Sho3","assetSelect":"index_assetSelect_1pOXF"};